import React, { Component } from 'react';
import CompanyItem from '../CompanyItem';
import './CompaniesList.css';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import PropTypes from 'prop-types';

class CompaniesList extends Component {
  static contextTypes = {
    width: PropTypes.number
  };

  static propTypes = {
    // Only this companies will be render by component.
    companiesForShow: PropTypes.arrayOf(PropTypes.string)
  }

  static defaultProps = {
    companiesForShow: []
  }

  setLengthModifier() {
    if (this.props.minify) {
      return 'col col--3'
    } else {
      if (this.props.data && this.props.data.length > 3) {
        return 'col col--3'
      } else if (this.props.data && this.props.data.length === 1) {
        return 'companyItem--once col col--12'
      } else {
        return 'col'
      }
    }
  }
  render() {
    this.colModifier = this.setLengthModifier();
    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      <div className={`companiesList row ${this.props.modifier ? this.props.modifier : ''} ${this.props.firstThreeIsBig ? 'companiesList--withBig' : ''}`}>
        {
          (this.props.data && this.props.data.length > 0) ?
          this.props.data.map((company, index) => {
            if(!this.props.companiesForShow.length) {
              return (
                <CompanyItem
                  minify={this.props.minify ? true : false}
                  modifier={this.colModifier + ((this.context.width > 800 && this.props.    firstThreeIsBig && index) < 3 ? ' col--4 companyItem--big' : '')}
                  key={`companyItem-${index}`}
                  card={company}
                />
              )
            }
            if (this.props.companiesForShow.find((el) => el === company.name)) {
                return (
                <CompanyItem
                  minify={this.props.minify ? true : false}
                  modifier={this.colModifier + ((this.context.width > 800 && this.props.    firstThreeIsBig && index) < 3 ? ' col--4 companyItem--big' : '')}
                  key={`companyItem-${index}`}
                  card={company}
                />
              )
            }
          }) :
          <div className="text text--bottom24">По данному запросу компаний нет</div>
        }
      </div>
    );
  }
}

export default CompaniesList;



// WEBPACK FOOTER //
// ./src/components/CompaniesList/index.js